meedy.factory('meedy.accountingService', ['$q', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $rootScope, baseService, objectHelper, config) {

        function AccountingService() {

            this.nipExistence = function(nip) {
                return baseService.get(config.API_URL + '/accountings/nipExistence/' + nip).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, ExistWrapperMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.regonExistence = function(regon) {
                return baseService.get(config.API_URL + '/accountings/regonExistence/' + regon).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, ExistWrapperMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
        }

        return new AccountingService();
    }
]);
